var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import '../../atoms/table-next/table-next.js';
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { SgdfElement } from '../../internal/sgdf-element.js';
import styles from './team-participant-list.styles.js';
/**
 * @summary Short summary of the component's intended use.
 * @status experimental
 * @since 1.0
 *
 * @dependency sgdf-example
 *
 * @event sgdf-event-name - Emitted as an example.
 *
 * @slot - The default slot.
 * @slot example - An example slot.
 *
 * @csspart base - The component's base wrapper.
 *
 * @cssproperty --example - An example CSS custom property.
 */
class SgdfTeamParticipantList extends SgdfElement {
    constructor() {
        super(...arguments);
        this.columns = [
            {
                id: 'first_name',
                accessorFn: row => { var _a; return (_a = row.usage_first_name) !== null && _a !== void 0 ? _a : row.first_name; },
                header: () => 'Prénom',
                cell: info => info.getValue(),
            },
            {
                id: 'last_name',
                accessorFn: row => { var _a; return (_a = row.usage_last_name) !== null && _a !== void 0 ? _a : row.last_name; },
                header: () => 'Nom',
                cell: info => info.getValue(),
            },
            {
                id: 'actions',
                enableColumnFilter: false,
                enableSorting: false,
                header: () => 'Actions',
                cell: info => {
                    const participant = info.row.original;
                    return html `
                    <div class="actions">
                        <sl-tooltip hoist content="Retirer de l'équipe">
                            <sgdf-icon-button
                                name=${'trash'}
                                @click=${(e) => {
                        e.preventDefault();
                        this.emit('sgdf-participant-picker:submit', {
                            detail: {
                                participants: this.participants
                                    .filter(p => p.id !==
                                    participant.id)
                                    .map(p => p.id),
                                teamId: this.teamId,
                            },
                        });
                    }}
                            >
                            </sgdf-icon-button>
                        </sl-tooltip>
                    </div>
                `;
                },
            },
        ];
    }
    render() {
        return html ` <sgdf-table-next
            .columns=${this.columns}
            .data=${this.participants}
        ></sgdf-table-next>`;
    }
}
SgdfTeamParticipantList.styles = styles;
export default SgdfTeamParticipantList;
__decorate([
    property({ type: Array, reflect: true })
], SgdfTeamParticipantList.prototype, "participants", void 0);
__decorate([
    property({ type: String, reflect: true })
], SgdfTeamParticipantList.prototype, "teamId", void 0);
//# sourceMappingURL=team-participant-list.component.js.map